import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { LoggedOutReturnType } from '../../../redux/loggedout';
import { ResourceType } from '../../../types/resource';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarB18Link from '../../_partials/items/ActionBarB18Link';
import { BiData, ProfileOrderCommissionBiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

export const OrderCommissionButton: React.FC<
  React.PropsWithChildren<Props>
> = ({ deviation, className }) => {
  const { t } = useTranslation();
  const isOpen = deviation.commission?.isActive ?? false;

  const { restrictToLoggedIn } = useRestrictToLoggedIn();
  const checkoutLink = deviation.commission?.subproductId
    ? Url.checkoutLink(deviation.commission?.subproductId)
    : undefined;

  return (
    <ActionBarItemWrapper className={className}>
      <ActionBarB18Link
        disabled={!isOpen}
        biData={BiData<ProfileOrderCommissionBiEvent>({
          evid: 293,
          typeid: ResourceType.COMMISSION,
          itemid: get(deviation, 'commission.commissionId'),
          points: get(deviation, 'commission.pointsCost'),
          creatorid: get(deviation, 'author.useridUuid'),
        } as any)}
        onClick={restrictToLoggedIn(
          ReferralType.ACTION_BAR,
          () => {
            if (checkoutLink) window.location.href = checkoutLink;
          },
          checkoutLink,
          LoggedOutReturnType.JOIN_ONLY
        )}
      >
        {t(isOpen ? 'actionbar.orderCommission' : 'actionbar.closedCommission')}
      </ActionBarB18Link>
    </ActionBarItemWrapper>
  );
};
OrderCommissionButton.displayName = 'OrderCommissionButton';

export default OrderCommissionButton;
